/* eslint-disable camelcase */
import React, {useEffect, useState} from 'react'
import {useStaticQuery, graphql} from 'gatsby'
import PropTypes from 'prop-types'
import Layout from '../components/layout'
import {globalStylesProtection} from '../constants'

import {isChrome, isUnsupported} from '../util/userAgent'

import {isExperiment, useExperiment} from '../experimentFramework/experiment'
import EXPERIMENT_CONFIG from '../experimentFramework/experimentConfig.json'

import SEO from '../components/seo'
import IndexUnsupported from '../components/unsupported/index-unsupported'
import ProtectionV1 from '../components/templates/protection-v1/ProtectionV1'
import ProtectionV2 from '../components/templates/protection-v2/ProtectionV2'

const ProtectionPage = ({languageCode = 'en'}) => {
    const site = useStaticQuery(graphql`
        query ProtectionPage {
            site {
                siteMetadata {
                    ...ProtectionLanding
                }
            }
        }
    `)
    const {landingSeoTags} = site.site.siteMetadata.privacyprotect[languageCode]
    const {title: seoTitle, description: seoDescription} = landingSeoTags
    const baseUrl = `https://add.startpage.com`

    const expConfig = useExperiment(EXPERIMENT_CONFIG)
    const [showUnsupportedPage, setShowUnsupportedPage] = useState(false)

    useEffect(() => {
        // for advertorials, redirect homepage to www.startpage.com - we only buy to nested routes for advertorial for now
        if (window.location.hostname.startsWith('private')) {
            window.location.href = 'https://www.startpage.com'
            return
        }
        if (isChrome()) {
            window.location.href = 'https://add.startpage.com'
            return
        }
        if (isUnsupported()) {
            setShowUnsupportedPage(true)
        }
    }, [expConfig])

    const ExperimentComponent = (config) => {
        if (!config) {
            return <></>
        }
        if (showUnsupportedPage) {
            return <IndexUnsupported experiment="unsupported" />
        }
        // NOTE: the following block is how you add a new experiment
        const {experiment} = config
        if (isExperiment(config, 'control')) {
            return <ProtectionV1 experiment={experiment} languageCode={languageCode} />
        }
        const isProtectionV2 =
            isExperiment(config, 'protection-v2-search') ||
            isExperiment(config, 'protection-v2-blocker') ||
            isExperiment(config, 'protection-v2-both')
        if (isProtectionV2) {
            return <ProtectionV2 experiment={experiment} languageCode={languageCode} />
        }
        // default fallback
        return <ProtectionV1 experiment={experiment} languageCode={languageCode} />
    }

    return (
        <Layout globalStyles={globalStylesProtection}>
            <SEO
                ogUrl={`${baseUrl}${languageCode !== 'en' ? `/${languageCode}` : ''}/protection/`}
                title={seoTitle}
                description={seoDescription}
                ogImagePath="https://www.startpage.com/sp/cdn/images/startpage-shield.png"
            />
            {ExperimentComponent(expConfig)}
        </Layout>
    )
}

ProtectionPage.propTypes = {
    languageCode: PropTypes.string,
}

ProtectionPage.defaultProps = {
    languageCode: `en`,
}

export default ProtectionPage
